// audienceに関するstore

import axios from 'axios';
import store from '../../store';

import consts from '../../utils/consts';

axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';

const state = {
  items: [],
  ticket_type_statuses: [],
  payment_status: [consts.PAY_STATUS.PAID],
  payment_methods: [],
  play_dates: [],
  ticket_types: [],
  search_word: '',
  per_page: 100,
  current_page: 1,
  total_audience_count: 0,
  total_audience_amount: 0,
  total_audience_fee_all: 0,
  total_audience_transfer: 0,
  admitted_audience_count: 0,
};

const getters = {
  // Audiencesを取得(イベントごとのaudienceを全件取得)
  getAudiencesFromEvent: (state) => {
    return state.items;
  },
  // Audiencesを取得(チケット種別IDでフィルター)
  getAudiencesByTid: (state) => (tid) => {
    return state.items.filter((item) => item.ticket_type_id === tid);
  },
  // TicketTypeStatusを取得(チケット種別IDでフィルター)
  getTicketTypeStatusByTid: (state) => (tid) => {
    return state.ticket_type_statuses.find((item) => item.id === tid);
  },
  // 開催日の絞り込みを設定する
  getPlayDates: (state) => {
    return state.play_dates;
  },
  // 券種の絞り込みを設定する
  getTicketTypes: (state) => {
    return state.ticket_types;
  },
  // 支払い条件の絞り込みを設定する
  getPaymentStatus: (state) => {
    return state.payment_status;
  },
  // 支払い方法の絞り込みを設定する
  getPaymentMethods: (state) => {
    return state.payment_methods;
  },
  // 現在のページ数
  getCurrentPage: (state) => {
    return state.current_page;
  },
  // 1ページあたりの表示件数
  getPerPage: (state) => {
    return state.per_page;
  },
  // 検索結果の合計件数
  getTotalAudienceCount: (state) => {
    return state.total_audience_count;
  },
  // 検索結果の支払額合計
  getTotalAudienceAmount: (state) => {
    return state.total_audience_amount;
  },
  // 検索結果の手数料合計
  getTotalAudienceFeeAll: (state) => {
    return state.total_audience_fee_all;
  },
  // 検索結果の振込額合計
  getTotalAudienceTransfer: (state) => {
    return state.total_audience_transfer;
  },
  // もぎり済みのaudienceの件数
  getAdmittedAudienceCount: (state) => {
    return state.admitted_audience_count;
  },
};

const actions = {
  // イベントに紐づくaudiencesを取得・検索条件があれば絞り込みをする
  async getAudiences({ commit, state }, { api_path, t, isAdmissionPage, is_assistant_admission_page }) {
    const ticketTypesIds = state.ticket_types.map(function (ticket_type) {
      return ticket_type.id;
    });
    const paymentStatusValues = state.payment_status.map(function (status) {
      return status.value;
    });
    const paymentMethodValues = state.payment_methods.map(function (methods) {
      return methods.value;
    });
    await axios.get(api_path + '?t=' + t + '&play_dates=' + state.play_dates + '&ticket_types=' + ticketTypesIds + '&search_word=' + state.search_word + '&payment_status=' + paymentStatusValues + '&payment_methods=' + paymentMethodValues + '&page=' + state.current_page + '&per=' + state.per_page + '&is_admission_page=' + isAdmissionPage + '&is_assistant_admission_page=' + is_assistant_admission_page).then((res) => {
      if (res.data.status != consts.API.STATUS_OK) {
        alert(res.data.message);
      } else {
        const audiences = res.data.data.audiences;
        const sub_audiences = res.data.data.sub_audiences;
        const combinated_audiences = audiences.concat(sub_audiences || []).sort((a, b) => (a.receipt_no ?? '').localeCompare((b.receipt_no ?? ''), undefined, {numeric: true}));
        commit('setAudiences', combinated_audiences);
        if (res.data.message.total_audience_count != undefined) {
          commit('setTotalAudienceCount', res.data.message.total_audience_count);
          commit('setTotalAudienceAmount', res.data.message.total_audience_amount);
          commit('setTotalAudienceFeeAll', res.data.message.total_audience_fee_all);
          commit('setTotalAudienceTransfer', res.data.message.total_audience_transfer);
        }
        if (res.data.message.admitted_audience_count != undefined) commit('setAdmittedAudiencesCount', res.data.message.admitted_audience_count);
      }
    });
  },
  // もぎる
  async accept_admission({ commit }, { program_id, event_id, admission_url, api_path, can_action_cable, countup }) {
    await axios
      .put(api_path, {
        url: admission_url,
        pid: program_id == null ? null : String(program_id),
        eid: event_id == null ? null : String(event_id),
        psum: 'false',
      })
      .then((res) => {
        if (res.data.status != consts.API.STATUS_OK) {
          alert(res.data.message);
        } else {
          if (doRefrectStore(can_action_cable)) {
            commit('setAudience', res.data.data.data);
            if (program_id == null) {
              commit('countupAdmittedAudiencesCount', countup);
            } else {
              commit('setTicketTypeStatus', res.data.data.meta);
            }
          }
        }
      });
  },

  // もぎり解除
  async unaccept_admission({ commit }, { program_id, event_id, admission_url, api_path, can_action_cable, countdown, assistant_id }) {
    await axios
      .put(api_path, {
        url: admission_url,
        pid: program_id == null ? null : String(program_id),
        eid: event_id == null ? null : String(event_id),
        psum: 'false',
        assistant_id: assistant_id
      })
      .then((res) => {
        if (res.data.status != consts.API.STATUS_OK) {
          alert(res.data.message);
        } else {
          if (doRefrectStore(can_action_cable)) {
            commit('setAudience', res.data.data.data);
            if (program_id == null) {
              commit('countdownAdmittedAudiencesCount', countdown);
            } else {
              commit('setTicketTypeStatus', res.data.data.meta);
            }
          }
        }
      });
  },
  updateAudience({ commit }, { edit_audience_path, data, csrf_token, audience_id }) {
    axios.defaults.headers.common['X-CSRF-Token'] = csrf_token;
    axios.put(edit_audience_path + '/' + audience_id, data).then((res) => {
      if (res.status != 200) {
        alert('エラーが発生しました。時間をおいてから改めてお試しください。');
      } else {
        commit('updateAudience', { data: res.data, audienceId: audience_id });
      }
    });
  },
  async refundAudience({ commit }, { refund_audience_path, data, csrf_token, audience_id, main_event_id }) {
    axios.defaults.headers.common['X-CSRF-Token'] = csrf_token
    // 失敗時(非2xx)はaxiosがrejectするため、ここでは握り潰さず呼び出し元へ伝播させる
    const res = await axios.put(refund_audience_path + '/' + audience_id + '/refund', data)
    commit('updateRefundAudience', { data: res.data, audienceId: audience_id, isFeeBurdenEventer: data.is_fee_burden_eventer })
  },
  // チケット無効化。返金には関与せずチケットの状態だけを変更する
  async invalidateAudience({ commit }, { invalidate_audience_path, csrf_token, audience_id }) {
    axios.defaults.headers.common['X-CSRF-Token'] = csrf_token
    const res = await axios.put(invalidate_audience_path + '/' + audience_id + '/invalidate')
    commit('updateInvalidatedAudience', { data: res.data, audienceId: audience_id })
  },
  // チケット無効化の取り消し
  async restoreAudience({ commit }, { restore_audience_path, csrf_token, audience_id }) {
    axios.defaults.headers.common['X-CSRF-Token'] = csrf_token
    const res = await axios.put(restore_audience_path + '/' + audience_id + '/restore')
    commit('updateInvalidatedAudience', { data: res.data, audienceId: audience_id })
  },
  async blockAudience({ commit }, { block_audience_path, data, csrf_token, owner_id, audience_id}) {
    axios.defaults.headers.common['X-CSRF-Token'] = csrf_token;
    await axios
      .post(block_audience_path, data)
      .then((res) => {
        if (res.status != 200) {
          alert('エラーが発生しました。時間をおいてから改めてお試しください。');
        } else {
          commit('updateBlockAudience', { data: res.data, ownerId: owner_id, allCancel: data.all_cancel, audienceID: audience_id});
        }
      })
  },
};

const mutations = {
  // 全てのaudienceをstateに設定する
  setAudiences(state, audiences) {
    state.items = audiences;
  },
  // 全てのaudienceをソートする
  sortAudiences(state, sortParam) {
    const regex = /[^0-9]/g;
    const audiences = state.items.sort((a, b) => {
      // 文字列を除いて数字でソートする
      const x = parseInt(a[sortParam.sortKey].replace(regex, ''));
      const y = parseInt(b[sortParam.sortKey].replace(regex, ''));
      return x === y ? 0 : x > y ? sortParam.sortOrder : -sortParam.sortOrder;
    });
    state.items = audiences;
  },
  // 1つのaudienceをstateに設定する
  setAudience(state, audience) {
    assignAudience(audience);
  },
  // 1つのaudienceをstateに設定する(強制)
  setAudienceForce(state, audience) {
    assignAudience(audience);
  },
  // ticket_typeの情報をstateに追加する
  pushTicketTypeStatus(state, ticket_type) {
    state.ticket_type_statuses.push(ticket_type);
  },
  // ticket_typeの情報をstateに設定する
  setTicketTypeStatus(state, ticket_type) {
    assignTicketType(ticket_type);
  },
  // 支払い条件の絞り込みを設定する
  setPaymentStatus(state, payment_status) {
    state.payment_status = payment_status;
  },
  setPaymentMethods(state, payment_methods) {
    state.payment_methods = payment_methods;
  },
  // 開催日の絞り込みを設定する
  setPlayDates(state, play_dates) {
    state.play_dates = play_dates;
  },
  // 券種の絞り込みを設定する
  setTicketTypes(state, ticket_types) {
    state.ticket_types = ticket_types;
  },
  // 検索ワードの絞り込みを設定する
  setSearchWord(state, search_word) {
    state.search_word = search_word;
  },
  // audienceの編集済み情報を更新する
  updateAudience(state, data) {
    const audience = state.items.find((item) => item.id === data.audienceId);
    audience.introducer = data.data.introducer;
    audience.event_questionnaire_answers = data.data.introducers;
    audience.introducer_tell = data.data.introducer_tell;
    audience.introducer_name = data.data.introducer_name;
    audience.introducer_adress = data.data.introducer_address;
    audience.note = data.data.note;
  },
  // audienceの払い戻し表示を更新する
  updateRefundAudience(state, data) {
    const audiences = state.items.filter((item) => item.audience_id === data.audienceId);
    // 表示を除く(=storeから取り除く)audiences
    const remove_audience_ids = [];
    audiences.map(function(audience) {
      if (audience.is_divide_ticket)  {
        // 分配チケット
        remove_audience_ids.push(audience.id);
      } else {
        const audienceBurdenFee = Math.round(parseInt(audience.price_safe) * audience.volume * audience.refund_fee_rate);
        if (data.isFeeBurdenEventer == 'true') {
          // 通常チケット
          // 主催者負担で払い戻しした場合
          audience.amount = '¥0';
          audience.audience_burden_fee = '¥' + audienceBurdenFee;
          audience.transfer_column = '¥' + (0 - audienceBurdenFee);
        } else {
          // 通常チケット
          // 購入者負担で払い戻しした場合
          audience.amount = '¥' + audienceBurdenFee;
          audience.audience_burden_fee = '¥' + audienceBurdenFee;
          audience.transfer_column = '¥0';
        }
        audience.cancel = true;
        audience.payment_status = 'キャンセル済';
        audience.can_invalidate = data.data.can_invalidate;
      }
    });
    removeSubAudiences(remove_audience_ids);
  },
  // チケット無効化の状態を更新する
  // 無効化可否はサーバー側の期間判定に依るためレスポンスの値をそのまま反映する
  updateInvalidatedAudience(state, data) {
    state.items
      .filter((item) => item.audience_id === data.audienceId && !item.is_divide_ticket)
      .map(function(audience) {
        audience.invalidated = data.data.invalidated;
        // 無効化できるのはconfirmが真の行だけなので、取り消したときの戻り先は必ず支払い済
        audience.payment_status = data.data.invalidated ? 'キャンセル済' : '支払い済';
        audience.can_invalidate = data.data.can_invalidate;
        audience.can_revoke_invalidation = data.data.can_revoke_invalidation;
      });
  },
  // audienceの通報表示を更新する
  updateBlockAudience(state, data) {
    const audiences = state.items.filter((item) => item.owner_id === data.ownerId);
    // 表示を除く(=storeから取り除く)audiences
    const remove_audience_ids = [];
    audiences.map(function(audience) {
      audience.is_blocked = true;
      if (data.allCancel == consts.ALL_CANCEL.YES) {
        if (audience.is_divide_ticket) {
          // 分配チケット
          remove_audience_ids.push(audience.id);
        } else {
          // 通常チケット
          audience.cancel = true;
          audience.payment_status = 'キャンセル済';
        }
      }
    });
    if (data.allCancel == consts.ALL_CANCEL.YES) {
      // 通報&キャンセルされたチケットの子audienceを対象に追加
      state.items.filter((item) => item.audience_id === data.audienceID).map(item => remove_audience_ids.push(item.id));
    }
    removeSubAudiences(remove_audience_ids);
  },
  // 現在のページ数を設定する
  setCurrentPage(state, current_page) {
    state.current_page = current_page;
  },
  // 1ページあたりの表示件数を設定する
  setPerPage(state, per_page) {
    state.per_page = per_page;
  },
  // 検索結果の合計件数を設定する
  setTotalAudienceCount(state, total_audience_count) {
    state.total_audience_count = total_audience_count;
  },
  // 検索結果の合計支払額を設定する
  setTotalAudienceAmount(state, total_audience_amount) {
    state.total_audience_amount = total_audience_amount;
  },
  // 検索結果の合計手数料を設定する
  setTotalAudienceFeeAll(state, total_audience_fee_all) {
    state.total_audience_fee_all = total_audience_fee_all;
  },
  // 検索結果の合計支払額を設定する
  setTotalAudienceTransfer(state, total_audience_transfer) {
    state.total_audience_transfer = total_audience_transfer;
  },
  // もぎり済みのaudienceの件数を設定する
  setAdmittedAudiencesCount(state, admitted_audience_count) {
    state.admitted_audience_count = admitted_audience_count;
  },
  // TODO: admitted_audience_countのカウントアップ方法は要改善
  // もぎられたaudienceの枚数をadmitted_audience_countに追加する
  countupAdmittedAudiencesCount(state, countup) {
    state.admitted_audience_count += countup;
  },
  // もぎり解除されたaudienceの枚数をadmitted_audience_countから引く
  countdownAdmittedAudiencesCount(state, countdown) {
    state.admitted_audience_count -= countdown;
  },
};

// audienceのstateを更新
function assignAudience(audience) {
  const item = state.items.find((item) => item.id === audience.id && item.is_divide_ticket === audience.is_divide_ticket);
  Object.assign(item, audience);
}

// ticket_typeのstateを更新
function assignTicketType(ticket_type) {
  const item = state.ticket_type_statuses.find((item) => item.id === ticket_type.ticket_type_id);
  Object.assign(item, ticket_type);
}

// storeへの反映
function doRefrectStore(can_action_cable) {
  // ActionCableの接続状態
  var actioncable_connect_status = store.getters['actioncable/connect_status'];
  if (!can_action_cable || (can_action_cable && actioncable_connect_status != consts.ACTION_CABLE.CONNETED)) {
    // ActionCableを使用しない、もしくは、ActionCableを使用するが接続できない
    return true;
  }
  return false;
}

// storeからsub_audiencesを削除する
function removeSubAudiences(ids){
  state.items = state.items.filter((item) => !(ids.includes(item.id) && item.is_divide_ticket));
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
